import React from 'react';
import pink_close from '../../pages_android/icons_android/pink_close.svg'
import share from '../../pages_android/icons_android/share.svg'
import ios_home_plus from '../../pages_android/icons_android/ios_home_plus.svg'
import { getLocalizedStrings } from '../../LocalizedStrings';

const strings = getLocalizedStrings()

const IosHomeScreen = ({ toogleSceenTooltip }) => (
    <div className="tooltip-how-do-it transformable-profiles ios_home_screen_plashka">
        <img onClick={toogleSceenTooltip} className="close_ios hover" src={pink_close} alt="" />
        <div className="pad_25">
            <div className="ios_home_screen_title">{strings.FAST_WRAPPING}<br />{strings.FAST_WRAPPING_2}</div>
            <p className="ios_home_screen_text">{strings.FAST_WRAPPING_CLICK}
                <img className="ios_home_image" src={share} alt="" /> {strings.FAST_WRAPPING_PICK}<br /> <img className="ios_home_image"
                    src={ios_home_plus} alt="" /> {strings.FAST_WRAPPING_HOME}
            </p>
        </div>
        <div className="ios_home_arrow"></div>
    </div>
);

export default React.memo(IosHomeScreen);
